import { render, staticRenderFns } from "./ConfigCreditAnalysisPendencias.vue?vue&type=template&id=493acc48&"
import script from "./ConfigCreditAnalysisPendencias.vue?vue&type=script&lang=js&"
export * from "./ConfigCreditAnalysisPendencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports